import React from 'react';
import styled from 'styled-components';
import {
  maxWidth, primaryFont, retina, scrollbar, wMedium,
} from 'Utils/utilsStyle';
import {
  selectAllUploadDocuments,
  selectBatchSize, selectFailedDocuments,
  // selectNextUploadDocuments,
  selectSuccessDocuments,
  selectUploadDocumentCount,
  // selectUploadDocuments,
  selectUploadLink,
} from 'Selector/DocumentHubSelector';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'Slice/DocumentHubSlice';
import classNames from 'classnames';
import { AllUploadDocument } from 'Types/DocumentHubTypes';
import DocumentInfoStatusCustom from './DocumentInfoStatusCustom';

const Wrapper = styled.div`
margin-top: 30px;
height: calc(100% - 280px);
.upload-statusbar-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* margin-bottom: 12px; */
}
.status-text {
  font-family: ${primaryFont};
  font-size: 16px;
  line-height: 15px; 
  font-weight: ${wMedium};
  letter-spacing: -0.417px;
  color: #A0A0A0;
  @media all and (max-width: ${maxWidth}), ${retina} {
    font-size: 14px;
  }
  &.cancel {
    display: flex;
    justify-content: flex-end;
    line-height: 25px;
    cursor: pointer;
    &:hover {
      color: #7E7E7E;
    }
  }
  &.disabled {
    cursor: none;
    opacity: 0.6;
  }
}
.multiple-file-upload-status-div {
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 30px);
  min-height: 100px;
  ${scrollbar};
  border-radius: 0px !important;
  padding: 10px 12px 10px 0px;
  .document-info-status-custom {
    margin-bottom: 16px;
    &.uploadComplete {
      margin-bottom: 0px;
    }
  }
}
`;

type Props = {
  uploading: boolean
  disableCancel: boolean
};

const MultipleFileUploadComponent = function MultipleFileUploadComponent(props: Props) {
  const { uploading, disableCancel } = props;
  const dispatch = useDispatch();
  const successDocuments = useSelector(selectSuccessDocuments);
  // const uplaodDocuments = useSelector(selectUploadDocuments);
  // const nextUploadDocuments = useSelector(selectNextUploadDocuments);
  const failedDocuments = useSelector(selectFailedDocuments);
  const uploadLink = useSelector(selectUploadLink);
  const batchSize = useSelector(selectBatchSize);
  const allUploadDocuments = useSelector(selectAllUploadDocuments);
  const uploadDocumentCount = useSelector(selectUploadDocumentCount);

  const onCancelClick = (doc: AllUploadDocument) => {
    dispatch(actions.chnageStatusUploadDocument(doc));
  };

  const statusText = `${uploading ? 1 + successDocuments.length : successDocuments.length}
   of ${batchSize} ${uploading ? 'Uploads' : 'Uploaded'}`;

  return (
    <Wrapper className="multiple-file-upload-component-style-wrapper">
      {uploading || successDocuments.length || uploadLink.length || failedDocuments.length ? (
        <div className="upload-statusbar-div">
          <span className="status-text">
            {batchSize ? statusText : ''}
          </span>
        </div>
      ) : null}
      {(uploading || successDocuments.length || failedDocuments.length) ? (
        <div className="multiple-file-upload-status-div">
          {allUploadDocuments.map((doc) => (
            <>
              {uploading && doc.status === 'pending' ? (
                <span
                  tabIndex={0}
                  role="button"
                  onKeyPress={() => onCancelClick(doc)}
                  onClick={() => onCancelClick(doc)}
                  className={classNames('status-text cancel', { disabled: disableCancel })}
                >
                  Cancel
                </span>
              ) : null}
              <DocumentInfoStatusCustom
                uploadDocument={doc}
                showStatus={false}
                uploadDocumentCount={uploadDocumentCount}
                finalResult={batchSize
                  === successDocuments.length + failedDocuments.length}
                inUploadProgress={doc.status === 'inProgress' || doc.status === 'pending'}
                successfullyUploaded={doc.status === 'success' || doc.status === 'failed'}
              />
            </>
          ))}
        </div>
      ) : null}
    </Wrapper>
  );
};
export default MultipleFileUploadComponent;
